import { observer } from 'mobx-react';
import * as React from 'react';
import DateInput from '../../../../../../../../Form/DateInput';
import TimeInput from '../../../../../../../../Form/TimeInput';
import TimeZoneSelect from '../../../../../../../../Form/TimeZoneSelect';
import InviteParticipantStore from '../../../../Store';
import { Inviting, Submitting } from '../../../../Types';

export interface Props {
  store: InviteParticipantStore;
  state: Inviting | Submitting;
}

const handleSubmit =
  (store: InviteParticipantStore) =>
  (e: React.SyntheticEvent): void => {
    e.preventDefault();
    store.submit();
  };

function Form({ store, state }: Props) {
  return (
    <form onSubmit={handleSubmit(store)} tabIndex={0} className="flex mt-6">
      <DateInput setDate={store.setDate} date={state.date} disabled={state.skipCommunications} />
      <TimeInput setTime={store.setTime} time={state.time} disabled={state.skipCommunications} />
      <TimeZoneSelect
        setTimezone={store.setTimezone}
        timezone={state.timezone}
        disabled={state.skipCommunications}
      />
      <input type="submit" hidden />
    </form>
  );
}

export default observer(Form);
